module.exports = __webpack_public_path__ + "static/financial-services-sectors-ed89ee303f575b03607d3a810956ea05.webp";